import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '../components/style.css'
const IndexPage = () => (


<div className="container d-flex align-items-center" style={{ height: "100vh" }} >
    <SEO title="Alvin T Zachariah | Software Engineer" />
    <div className="jumbo" >
      <h3 className="animated fadeInDwon delay-1s">Hello world ! I am</h3>
      <h1 className="head animated fadeInLeft delay-1.2s">Alvin</h1>
      <h1 className="sub animated fadeInRight delay-1.2s">zachariah .</h1>
      <div className="desc col-md-6 animated fadeInUp delay-2s">
        <div className="margin animated infinite flash delay-2s"></div>
        A software engineer in the making . Full stack developer with fair amount of experience in MEAN Stack .
      </div>
      <div className="my-3">
      <a  className="social" target="_blank" href="https://stackoverflow.com/users/4623462/alvin-zachariah"><i class="fab fa-stack-overflow"></i></a>
      <a  className="social" target="_blank"  href="https://github.com/alvinzach"><i class="fab fa-github"></i></a>
      <a  className="social" target="_blank"  href="https://www.linkedin.com/in/alvinzach/"><i class="fab fa-linkedin"></i></a>
      </div>
    </div>
  </div>


)

export default IndexPage
